
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class BasePrice extends Vue {
  @Prop({ default: "h4 mb-0" }) colClasses!: string;
  @Prop() basePrice!: any;
}
